/**
 * @generated SignedSource<<092db803b510c1e28fa1bd5256d5b47f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NetworkOwnerMutationGroup",
    "kind": "LinkedField",
    "name": "networkOwner",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "NetworkOwnerModifyPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NetworkOwner",
            "kind": "LinkedField",
            "name": "networkOwner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NewNetworkOwnerModal_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NewNetworkOwnerModal_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f2991455b65dbb9a85efb71fb0237aa6",
    "id": null,
    "metadata": {},
    "name": "NewNetworkOwnerModal_Mutation",
    "operationKind": "mutation",
    "text": "mutation NewNetworkOwnerModal_Mutation(\n  $name: String!\n) {\n  networkOwner {\n    create(input: {name: $name}) {\n      networkOwner {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e441dadfb59cb62c655ee95d3a348624";

export default node;
